import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgTransparantInformatie = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#0061CD"
      fillRule="evenodd"
      d="M6 14h6l2 2h18v16H6z"
      clipRule="evenodd"
    />
    <path
      fill="#CEE5F8"
      d="M27.694 7.647 14.03 10.694l4.266 19.13 13.664-3.047z"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="m26.729 12.468-10.35 2.31-.218-.976 10.35-2.31zM25.429 15.838l-8.4 1.87-.218-.976 8.4-1.87zM28.029 18.328l-10.34 2.31-.218-.976 10.34-2.31z"
      clipRule="evenodd"
    />
    <path
      fill="#85BDED"
      fillRule="evenodd"
      d="M36 18H10L6 32h26z"
      clipRule="evenodd"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgTransparantInformatie);

export default ForwardRef;
